import React, { useEffect } from 'react'
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AddQuote } from './AddQuote';
import { QuoteDetails } from './QuoteDetails';
import { getHotelsList } from '../../../store/slices/general/thunks';

export const QuoteScreen = () => {
  const dispatch = useDispatch();
  const { quoteType2 } = useSelector((state) => state.quotes);
  const [addLodgingRoomCategory, setAddLodgingRoomCategory] = useState(false);

  useEffect(() => {
    dispatch(getHotelsList());
  }, [])

  return (
    <div>
      <button className="btn btn-light btn-icon" style={{ marginTop: 20 }}
        onClick={() => setAddLodgingRoomCategory(true)} >Crear Cotizacion</button>
      <AddQuote isOpen={addLodgingRoomCategory} setIsOpen={setAddLodgingRoomCategory} />

      {
        quoteType2 && quoteType2.id && <QuoteDetails quote={quoteType2} />
      }
    </div>
  )
}
